import { StateCreator } from 'zustand';

import { CompanyFormFields } from 'app/components/Companies/CreateCompany/CreateCompanyForm/types';

import { CreateCompanySlice } from './types';

const initialState: CompanyFormFields = {
  name: '',
  displayName: '',
  countryCode: 'GB',
  companyNumber: '',
  feeGroup: undefined,
  addressLine1: '',
  addressLine2: '',
  city: '',
  postcode: '',
  type: 'STANDARD',
  partnerId: undefined,
};

const createCompanySlice: StateCreator<CreateCompanySlice> = (set) => ({
  companyData: initialState,
  setCompanyData(companyData) {
    set((state) => ({ companyData: { ...state.companyData, ...companyData } }));
  },

  resetCompanyData() {
    set({ companyData: initialState });
  },
});

export default createCompanySlice;
